export default __webpack_public_path__ + "static/media/speakers-border.c14c5476.svg";